
import { Request } from "@/api/request";
import { defineComponent, ref,reactive, inject, onMounted, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { storeUser } from "@/store/User";
import {
    getOrderCarMountings,
} from "@/api/http";
import {column} from "@/assets/types/common";

type dialogSelect = {
    search?: string;
};

const partsColumn: Array<column> = [
    {
        prop: "name",
        label: "配件名称",
        width: 84,
    },
    
    {
        prop: "specification",
        label: "规格",
        width: 84,
    },
    {
        prop: "mountings_type_name",
        label: "配件分类",
        width: 84,
    },
    {
        prop: "mountings_brand_name",
        label: "品牌",
        width: 84,
    },
    {
        prop: "mountings_unit_name",
        label: "单位",
        width: 84,
    },
    {
        prop: "price",
        label: "价格",
        width: 84,
    },
    {
        prop: "stock",
        label: "库存",
        width: 84,
    },
];
export default defineComponent({
    name: "projectParts",
    setup() {
        const Router = useRouter();
        const Route = useRoute();
        const setTitle: any = inject("setTitle"),
            headClass = inject("headClass");
        setTitle(["运营管理", "尊享卡项目"]);
        let user = storeUser.getUser(),
            form: any = ref({
                class_name: "",
            }),
            dialog_show = ref({
                parts: false
            } as any),
            formRef: any = ref(null),
            tableData = ref([[], []] as any),
            loading = ref(false),
            partsTable = ref([]),
            dialogVisible = ref(false),
            dialogType = ref(1),
            dialogSelect = ref({} as dialogSelect),
            project_id: any = ref(0),
            add = () => {
                dialog_show.value.parts = true
            },
            deleteParts = (selection: any) => {
                Request.axiosInstance({
                    url: "adminapi/Project/deletePart",
                    data: {
                        id:selection.id,
                        project_id
                    },
                }).then((res: any) => {
                    if (res.status == 202) {
                        getPartsList();
                    }
                });
            },
            // 获取配件列表
            getPartsList = () => {
                loading.value = true;
                Request.axiosInstance({
                    url: "adminapi/Project/projectPartsList",
                    data: {
                        project_id
                    },
                }).then((res: any) => {
                    loading.value = false;
                    tableData.value = res?.content?.list || [];
                });
            },
            getOrderMountings = (): void => {
                getOrderCarMountings(dialogSelect.value).then((res: any) => {
                    if(res.status == 200){
                        partsTable.value = res?.content?.mountings_data?.list || [];
                    }
                    console.log(partsTable.value)
                });
            },
            dialogSelectChange = (
                value: string | number,
                key: keyof dialogSelect
            ): void => {
                if (!value) {
                    delete dialogSelect.value[key];
                }
                getOrderMountings();
            },
            updateNumber = (selection: any) => {
                console.log(selection)
                Request.axiosInstance({
                    url: "adminapi/Project/editPart",
                    data: {
                        id:selection.id,
                        project_id,
                        number:selection.number,
                    },
                }).then((res: any) => {
                    if (res.status == 202) {
                        getPartsList();
                    }
                });
            },
            handleCurrentChange = (selection:any) => {
                console.log(selection)
                Request.axiosInstance({
                    url: "adminapi/Project/addPart",
                    data: {
                        parts_id:selection.id,
                        project_id
                    },
                }).then((res: any) => {
                    if (res.status == 202) {
                        dialog_show.value.parts = false
                        getPartsList();
                    }
                });
            };
            
        
        onMounted(() => {
            project_id = Route.query.project_id;
            getPartsList();
            getOrderMountings();
        });
        
        return {
            headClass,
            partsColumn,
            dialog_show,
            form,
            formRef,
            dialogType,
            partsTable,
            add,
            deleteParts,
            tableData,
            updateNumber,
            loading,
            user,
            dialogSelect,
            dialogSelectChange,
            handleCurrentChange,
        };
    },
});
